import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	securityPermissionsImageAlt: {
		id: 'servicedesk-request-type-security.common.generic-empty-state.security-permissions-image-alt',
		defaultMessage: 'Illustration of a lock',
		description: 'Alt text for the security permissions image in the issue security empty state.',
	},
});
